// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/conditions-generals-cars/list',
    name: 'conditions-generals-cars-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/cars/ConditionGeneral.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_conditions_generals_cars',
    },
  },
  {
    path: '/conditions-generals-cars/update',
    name: 'conditions-generals-cars-update',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/cars/form/ConditionsGeneral.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_conditions_generals_cars',
    },
  },
]

export default formTable
